import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { NotificationsApi } from "../api/Endpoints/Notifications";

const POLL_MS = 60000;

export const useNotifications = (params = { limit: 20 }, options = {}) =>
  useQuery({
    queryKey: ["notifications", params],
    queryFn: () => NotificationsApi.list(params),
    refetchInterval: POLL_MS,
    enabled: options.enabled ?? true,
    // envelope → { data: [...], unread }
    select: (res) => res?.data?.data || { data: [], unread: 0 },
  });

export const useUnreadNotificationCount = () =>
  useQuery({
    queryKey: ["notifications", "unread-count"],
    queryFn: () => NotificationsApi.unreadCount(),
    refetchInterval: POLL_MS,
    select: (res) => res?.data?.data?.unread || 0,
  });

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => NotificationsApi.markRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["notifications"] }),
  });
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => NotificationsApi.readAll(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["notifications"] }),
  });
};
